module.exports = __webpack_public_path__ + "produce-fresh-grass-14.jpg?afb15c7c71847fb4b68976a9b11e6a13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-14.jpg
// module id = 51
// module chunks = 0